<template>
  <section
    class="slide sec3 whiteSlide bg-white overflow-hidden opacity-0 fixed w-full h-full text-black"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap table-cell align-middle">
          <div class="fix-width max-w-1114px ml-auto mr-auto">
            <ul class="grid sec-details ml-spc16 mr-spc16">
              <li
                class="col-6-12 mt-spc13 max-w-589 w-full pl-6 pr-6 block text-center"
                id="productImage1"
              >
                <SliderOne :slideDatas="mjSliderData" />
              </li>
              <li class="col-6-12 left max-w-589 w-full pl-6 pr-6 block">
                <SectionDetailsContent
                  :title="title"
                  colors
                  fabrics
                  :descBoldText="descBoldText"
                  :desc="desc"
                  :desc2BoldText="desc2BoldText"
                  :desc2="desc2"
                  :sizes="sizes"
                  :prices="prices"
                  btn1title="Purchase"
                  btn2title="Enquiries"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderOne from "../sliders/slider1/SliderOne";
import SectionDetailsContent from "../common/SectionDetailsContent";

let mjSliderData = {
  sliderID: "27",
  mjSliders: [
    {
      active: true,
      img: require("@/assets/images/products/thumbfly1.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/new-02-thumbfly2.jpg")
    },
    {
      active: false,
      img: require("@/assets/images/products/new-03-thumbfly3.jpg")
    },
    {
      active: false,
      img: require("@/assets/images/products/new-04-thumbfly4.jpg")
    }
  ]
};

export default {
  name: "Section3",
  components: {
    SectionDetailsContent,
    SliderOne
  },
  data: function() {
    return {
      title: "FLYAWAY STICKS",
      descBoldText: "THE MODERN BLEND",
      desc:
        "Modern blend of clove, geranium, Texas cedar, citronella and other ingredients.",
      desc2BoldText: "FOUND IN FIELD, GARDEN & ROOMS",
      desc2:
        "At gatherings, in either an outdoor or an indoor/outdoor setting, an evening by the dip pool, a farm-to-table, in garden room or summer beach house, camping under the stars with your pet animals, or planting, pruning, picking or weeding in the great outdoors. Best moments after dusk.",
      sizes: {
        sticks: "25 STICKS",
        sticks2: "50 STICKS",
        stickoutland: "200 STICKS OUTLANDISH EVENT"
      },
      prices: {
        price1: "$28",
        price2: "$48",
        price3: "$120"
      },
      mjSliderData
    };
  }
};
</script>

<style scoped>
</style>